import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useShortcuts() {
  const $ = _c(4);
  const [shortcutsModalOpen, setShortcutsModalOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleKeyDown = event => {
        if (event.target instanceof HTMLElement && (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA" || event.target.isContentEditable)) {
          return;
        }
        if (event.key === "?" && !event.metaKey && !event.ctrlKey && !event.altKey) {
          event.preventDefault();
          setShortcutsModalOpen(_temp);
        }
        if (event.key === "Escape") {
          setShortcutsModalOpen(false);
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== shortcutsModalOpen) {
    t2 = {
      shortcutsModalOpen,
      setShortcutsModalOpen
    };
    $[2] = shortcutsModalOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(prev) {
  return !prev;
}